import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=a48e4c18&scoped=true"
import script from "./Header.js?vue&type=script&lang=js&external"
export * from "./Header.js?vue&type=script&lang=js&external"
import style0 from "./Header.scss?vue&type=style&index=0&id=a48e4c18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48e4c18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default,HotLink: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default,HotAnchor: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Anchor/Anchor.vue').default,HotOrganicLinkSubmenu: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Organic/LinkSubmenu/LinkSubmenu.vue').default,HotButton: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Button/Button.vue').default})
